import { render, staticRenderFns } from "./DefinedBenefitReportDocument.vue?vue&type=template&id=55f7abac&"
import script from "./DefinedBenefitReportDocument.vue?vue&type=script&lang=ts&"
export * from "./DefinedBenefitReportDocument.vue?vue&type=script&lang=ts&"
import style0 from "./DefinedBenefitReportDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports